import { render, staticRenderFns } from "./details-caches.vue?vue&type=template&id=6594d8c6&"
import script from "./details-caches.vue?vue&type=script&lang=js&"
export * from "./details-caches.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports